import axios from '@axios'

const PREFIX = 'cnd-portal-documentos'

export default {

  getPaginado(page, pageSize, filtros, filtroString, idFiltroCustom) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}&multiFiltro=${filtroString}&idFiltroCustom=${idFiltroCustom}`, filtros)
  },

  getURL(id, coluna, isPorEmpresa = false) {
    return axios.get(`${PREFIX}/url?empresaId=${id}&coluna=${coluna}&porEmpresa=${isPorEmpresa}`)
  },

  baixaEmLote(filtroDocs, nome, baixarLinha = false) {
    return axios.post(`${PREFIX}/baixa-lote?nomeArquivo=${nome}&baixarLinha=${baixarLinha}`, filtroDocs)
  },

  enviarEmLote(nome, filtroDocs) {
    return axios.post(`${PREFIX}/enviar-email?nomeArquivo=${nome}`, filtroDocs)
  },

  getObservacoes(id, tipo) {
    return axios.post(`${PREFIX}/${id}/observacao?tipo=${tipo}`)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  baixarEmExcel(tipoCnd, filtroDoc) {
    return axios.post(`${PREFIX}/${tipoCnd}/baixa-excel`, filtroDoc)
  },

  deletarExcel(url, nomeArquivo) {
    axios.post(`${PREFIX}/deletar-excel?url=${url}&nomeArquivo=${nomeArquivo}`)
  },

  getHistorico(tipoCnd, id, filtros) {
    return axios.post(`${PREFIX}/historico?empresaId=${id}&tipo=${tipoCnd}`, filtros)
  },

  notificaHistorico(tipo, nomeEmpresa, emailEmpresa, emailCc, mensagemAdicional, definirEmailPadrao, ids) {
    return axios.post(`${PREFIX}/notifica-historico?tipo=${tipo}&emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`, ids)
  },

  baixarEmExcelEspecifico(dto) {
    return axios.post(`${PREFIX}/baixa-excel-selecionados`, dto)
  },

  baixarSelecionados(tipo, ids) {
    return axios.post(`${PREFIX}/baixar-selecionadas?tipo=${tipo}`, ids)
  },

  GetUrlWhatsApp(tipo, ids) {
    return axios.post(`${PREFIX}/url-whatsapp?tipo=${tipo}`, ids)
  },

  getTodasLinhas(filtros, filtroString, filtroCustomId) {
    return axios.post(`${PREFIX}/allPaged?multiFiltro=${filtroString}&filtroCustomId=${filtroCustomId}`, filtros)
  },

}
